import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListPrestationComponent } from './list-prestation/list-prestation.component';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { PrestationModalAjoutComponent } from './modal/prestation-modal-ajout/prestation-modal-ajout.component';
import { PrestationFormComponent } from './prestation-form/prestation-form.component';
import { DetailPrestationComponent } from './detail-prestation/detail-prestation.component';
import { SuiviPrestationFormComponent } from './suiviPrestation/suiviPrestation-form/suiviPrestation-form.component';
import { SuiviPrestationModalAjoutComponent } from './suiviPrestation/suiviPrestation-modal-ajout/suiviPrestation-modal-ajout.component';
import { PrestationModalDetailSuiviPrestationComponent } from './modal/prestation-modal-detail-suiviPrestation/prestation-modal-detail-suiviPrestation.component';
import { PrestationModalChooseIntervenantComponent } from './modal/prestation-modal-choose-intervenant/prestation-modal-choose-intervenant.component';
import { ActivitePrestationFormComponent } from './activitePrestation/activitePrestation-form/activitePrestation-form.component';
import { ActivitePrestationModalAjoutComponent } from './activitePrestation/activitePrestation-modal-ajout/activitePrestation-modal-ajout.component';
import { PrestationModalDetailActivitePrestationComponent } from './modal/prestation-modal-detail-activitePrestation/prestation-modal-detail-activitePrestation.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgxEditorModule } from 'ngx-editor';
import { NavPrestationModule } from '../nav-prestation/nav-prestation.module';
import { PrestationFichierModalAjoutComponent } from './prestationFichier/prestationFichier-modal-ajout/prestationFichier-modal-ajout.component';
import { PrestationFichierFormComponent } from './prestationFichier/prestationFichier-form/prestationFichier-form.component';
import { RestitutionPrestationModalAjoutComponent } from './restitutionPrestation/restitutionPrestation-modal-ajout/restitutionPrestation-modal-ajout.component';
import { RestitutionPrestationFormComponent } from './restitutionPrestation/restitutionPrestation-form/restitutionPrestation-form.component';
import { PrestationModalDetailRestitutionPrestationComponent } from './modal/prestation-modal-detail-restitutionPrestation/prestation-modal-detail-restitutionPrestation.component';
import { AccordionComponent } from 'ngx-bootstrap/accordion';


@NgModule({
	declarations: [
		PrestationFormComponent,
		DetailPrestationComponent,
		ListPrestationComponent,
		PrestationModalAjoutComponent,
		PrestationModalDetailSuiviPrestationComponent,
		SuiviPrestationFormComponent,
		PrestationFichierFormComponent,
		SuiviPrestationModalAjoutComponent,
		PrestationModalDetailActivitePrestationComponent,
		ActivitePrestationFormComponent,
		ActivitePrestationModalAjoutComponent,
		PrestationModalDetailRestitutionPrestationComponent,
		RestitutionPrestationFormComponent,
		RestitutionPrestationModalAjoutComponent,
		PrestationFichierModalAjoutComponent,
		PrestationModalChooseIntervenantComponent
	],
	imports: [SharedModule, NgxSliderModule, NgxEditorModule, NavPrestationModule],
	providers: [DateUtils, AccordionComponent]
})
export class PrestationsModule {}
